import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ClinicalServiceTypes } from "../../text/data";
import MedicationReviewForms from "../services/medication-review/documentationForm";
import MinorAilemntForms from "../services/minor-ailment/documentationForm";
import PatientChartForm from "../../../forms/patient-chart-forms/PatientChartForm";
import { useEffect } from "react";
import { fetchNotepadByService } from "../../../../redux/modules/patient/actions";

const LoadSummaryForms = ({}) => {
  const { id: patientId, formType, summaryId, type } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    medications,
  } = useSelector((state) => state.clinicalService);
  const { patient } = useSelector((state) => state.patients);
  const { medicalSummaryRecord } = useSelector((state) => state.medicalSummary);

  // Fetch notepad data for completed clinical services by summaryId and service type
  useEffect(() => {
    const serviceType = medicalSummaryRecord?.minorAilmentTypeCode || medicalSummaryRecord?.medicationReviewTypeCode;
    if (summaryId && serviceType) {
      dispatch(fetchNotepadByService(serviceType, summaryId));
    }
  }, [summaryId, medicalSummaryRecord, dispatch]);

  const renderStep = () => {
    // If a patient-chart form is requested, render it
    if (formType === 'patientChart') {
      return (
        <PatientChartForm
          patient={patient}
        />
      );
    }
    // Get the service type from either minorAilmentTypeCode or medicationReviewTypeCode
    const serviceType = medicalSummaryRecord?.minorAilmentTypeCode || medicalSummaryRecord?.medicationReviewTypeCode;
    
    switch (serviceType) {
      case ClinicalServiceTypes.AllergicRhinitis:
        return (
          <MinorAilemntForms
            clinicalServiceObj={medicalSummaryRecord}
            clinicalServiceName={serviceType}
            patient={patient}
            formType={formType}
            onBack={(e) => {
              // Preserve selectedRowId from URL query params when navigating back
              const urlParams = new URLSearchParams(location.search);
              const selectedRowId = urlParams.get('selectedRowId');
              const returnTo = urlParams.get('returnTo');
              
              // If returnTo is specified, use it; otherwise use the current type
              const backType = returnTo || type;
              
              const backUrl = selectedRowId 
                ? `/patient/${patientId}/medical-summary/${backType}${backType === 'NOTES' ? '' : `/${summaryId}`}?selectedRowId=${selectedRowId}`
                : `/patient/${patientId}/medical-summary/${backType}${backType === 'NOTES' ? '' : `/${summaryId}`}`;
              navigate(backUrl);
            }}
          />
        );
      case ClinicalServiceTypes.MedicationReview:
        return (
          <MedicationReviewForms
            clinicalServiceObj={medicalSummaryRecord}
            clinicalServiceName={serviceType}
            medications={medications}
            patient={patient}
            formType={formType}
            onBack={(e) => {
              // Preserve selectedRowId from URL query params when navigating back
              const urlParams = new URLSearchParams(location.search);
              const selectedRowId = urlParams.get('selectedRowId');
              const returnTo = urlParams.get('returnTo');
              
              // If returnTo is specified, use it; otherwise use the current type
              const backType = returnTo || type;
              
              const backUrl = selectedRowId 
                ? `/patient/${patientId}/medical-summary/${backType}${backType === 'NOTES' ? '' : `/${summaryId}`}?selectedRowId=${selectedRowId}`
                : `/patient/${patientId}/medical-summary/${backType}${backType === 'NOTES' ? '' : `/${summaryId}`}`;
              navigate(backUrl);
            }}
          />
        );
      default:
        // Default fallback for unknown service types
        return (
          <>Something went wrong! Contact Technical Team</>
        );
    }
  };

  return <div className="">{renderStep()}</div>;
};

export default LoadSummaryForms;
